<template>
  <div class="widgets-wrap" v-show="isLanternVisible">
    <el-popconfirm
      title="如需关闭灯笼显示，可前往设置页面进行配置"
      confirm-button-text="去设置"
      cancel-button-text="知道了"
      @confirm="goToSettings"
    >
      <template #reference>
        <div class="deng-box">
          <div class="deng">
            <div class="xian"></div>
            <div class="deng-a">
              <div class="deng-b"><div class="deng-t">年</div></div>
            </div>
            <div class="shui shui-a">
              <div class="shui-c"></div>
              <div class="shui-b"></div>
            </div>
          </div>
        </div>
      </template>
    </el-popconfirm>

    <el-popconfirm
      title="如需关闭灯笼显示，可前往设置页面进行配置"
      confirm-button-text="去设置"
      cancel-button-text="知道了"
      @confirm="goToSettings"
    >
      <template #reference>
        <div class="deng-box1">
          <div class="deng">
            <div class="xian"></div>
            <div class="deng-a">
              <div class="deng-b"><div class="deng-t">新</div></div>
            </div>
            <div class="shui shui-a">
              <div class="shui-c"></div>
              <div class="shui-b"></div>
            </div>
          </div>
        </div>
      </template>
    </el-popconfirm>
  </div>
</template>

<script>
export default {
  methods: {
    goToSettings() {
      this.$router.push("/setting#decoration");
    },
  },
  computed: {
    isLanternVisible() {
      return this.$store.state.configInfo?.decoration?.isOpenLantern ?? false;
    },
  },
};
</script>

<style scoped>
@media (max-width: 759px) {
  .deng-box {
    transform: scale(0.5); /* 整体缩放0.5倍 */
    transform-origin: right top; /* 从左上角开始缩放 */
    position: fixed;
    top: 36px;
    right: -20px;
    z-index: 2;
  }

  .deng-box1 {
    transform: scale(0.5); /* 整体缩放0.5倍 */
    transform-origin: right top; /* 从左上角开始缩放 */
    position: fixed;
    top: 46px;
    right: 10px;
    z-index: 2;
  }
}

@media (min-width: 760px) {
  .deng-box {
    position: fixed;
    top: 0px;
    left: 20px;
    z-index: 2;
  }

  .deng-box1 {
    position: fixed;
    top: 10px;
    left: -20px;
    z-index: 2;
  }
}

.deng-box1 .deng {
  position: relative;
  width: 120px;
  height: 90px;
  margin: 50px;
  background: #d8000f;
  background: rgba(216, 0, 15, 0.8);
  border-radius: 50% 50%;
  -webkit-transform-origin: 50% -100px;
  -webkit-animation: swing 7s infinite ease-in-out;
  box-shadow: -5px 5px 30px 4px rgba(252, 144, 61, 1);
}

.deng {
  position: relative;
  width: 120px;
  height: 90px;
  margin: 50px;
  background: #d8000f;
  background: rgba(216, 0, 15, 0.8);
  border-radius: 50% 50%;
  -webkit-transform-origin: 50% -100px;
  -webkit-animation: swing 10s infinite ease-in-out;
  box-shadow: -5px 5px 50px 4px rgba(250, 108, 0, 1);
}

.deng-a {
  width: 100px;
  height: 90px;
  background: #d8000f;
  background: rgba(216, 0, 15, 0.1);
  margin: 12px 8px 8px 8px;
  border-radius: 50% 50%;
  border: 2px solid #dc8f03;
}

.deng-b {
  width: 45px;
  height: 90px;
  background: #d8000f;
  background: rgba(216, 0, 15, 0.1);
  margin: -4px 8px 8px 26px;
  border-radius: 50% 50%;
  border: 2px solid #dc8f03;
}

.xian {
  position: absolute;
  top: -60px;
  left: 60px;
  width: 2px;
  height: 60px;
  background: #dc8f03;
}

.shui-a {
  position: relative;
  width: 5px;
  height: 20px;
  margin: -5px 0 0 59px;
  -webkit-animation: swing 4s infinite ease-in-out;
  -webkit-transform-origin: 50% -45px;
  background: #ffa500;
  border-radius: 0 0 5px 5px;
}

.shui-b {
  position: absolute;
  top: 14px;
  left: -2px;
  width: 10px;
  height: 10px;
  background: #dc8f03;
  border-radius: 50%;
}

.shui-c {
  position: absolute;
  top: 18px;
  left: -2px;
  width: 10px;
  height: 35px;
  background: #ffa500;
  border-radius: 0 0 0 5px;
}

.deng:before {
  position: absolute;
  top: -7px;
  left: 29px;
  height: 12px;
  width: 60px;
  content: " ";
  display: block;
  z-index: 999;
  border-radius: 5px 5px 0 0;
  border: solid 1px #dc8f03;
  background: #ffa500;
  background: linear-gradient(
    to right,
    #dc8f03,
    #ffa500,
    #dc8f03,
    #ffa500,
    #dc8f03
  );
}

.deng:after {
  position: absolute;
  bottom: -7px;
  left: 10px;
  height: 12px;
  width: 60px;
  content: " ";
  display: block;
  margin-left: 20px;
  border-radius: 0 0 5px 5px;
  border: solid 1px #dc8f03;
  background: #ffa500;
  background: linear-gradient(
    to right,
    #dc8f03,
    #ffa500,
    #dc8f03,
    #ffa500,
    #dc8f03
  );
}

.deng-t {
  font-family: "楷体", "楷体_GB2312", "标楷体", KaiTi, KaiTi_GB2312, STKaiti,
    "华文楷体", Arial, sans-serif;
  font-size: 3.2rem;
  color: #dc8f03;
  font-weight: bold;
  line-height: 85px;
  text-align: center;
}

.night .deng-t,
.night .deng-box,
.night .deng-box1 {
  background: transparent !important;
}

@-moz-keyframes swing {
  0% {
    -moz-transform: rotate(-8deg);
  }

  50% {
    -moz-transform: rotate(8deg);
  }

  100% {
    -moz-transform: rotate(-8deg);
  }
}

@-webkit-keyframes swing {
  0% {
    -webkit-transform: rotate(-8deg);
  }

  50% {
    -webkit-transform: rotate(8deg);
  }

  100% {
    -webkit-transform: rotate(-8deg);
  }
}

.deng-box,
.deng-box1 {
  cursor: pointer; /* 添加手型光标 */
}
</style>
